module.exports = __webpack_public_path__ + "html/landing-new-bottom_6e7a285c8f892ae5b842d2d0d55db925.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/landing-new-bottom.html
// module id = gkLk
// module chunks = 51